import { QuizInputTemplate } from '@efdigital/ll-addon-content/components/quiz/types';
import {
  addPageBreak,
  hasPageBreak,
  removePageBreak,
} from '@efdigital/ll-addon-content/utils/quiz-css-class';
import { uniqueId } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import type { QuizQuestionEditorComponentSignature } from '../../types/question-manager';

export class MetaQuestionEditorComponent extends Component<QuizQuestionEditorComponentSignature> {
  get hasPageBreak(): boolean {
    return hasPageBreak(this.args.question.css || '');
  }

  onPageBreakChange = (event: Event) => {
    const checked = (event.target as HTMLInputElement).checked;
    const currentCss = this.args.question.css || '';

    if (checked && !hasPageBreak(currentCss)) {
      this.args.question.css = addPageBreak(currentCss);
    } else if (!checked && hasPageBreak(currentCss)) {
      this.args.question.css = removePageBreak(currentCss);
    }

    const hasPageBreaks = this.args.quiz.questions.some((q) =>
      hasPageBreak(q.css || '')
    );

    const inputTemplate: string = hasPageBreaks
      ? QuizInputTemplate.Paged
      : QuizInputTemplate.Default;
    if (inputTemplate !== this.args.quiz.templateInput) {
      this.args.quiz.templateInput = inputTemplate;
    }
  };

  <template>
    <div class="card-body">
      <h4 class="gud-eyebrow">Page Break</h4>

      <div class="form-text mb-3">
        When a question starts a new page, its title will be used as the page
        title in the quiz navigation. This is typically used for section headers
        or to break up long quizzes into manageable parts.
      </div>

      {{#let (uniqueId) as |uniqueId|}}
        <div class="form-check mb-3">
          <input
            id={{uniqueId}}
            type="checkbox"
            class="form-check-input"
            checked={{this.hasPageBreak}}
            {{on "change" this.onPageBreakChange}}
          />
          <label for={{uniqueId}} class="form-check-label">
            Start a new page
          </label>
        </div>
      {{/let}}

      {{#unless @index}}
        <div class="alert alert-info mb-0">
          <strong>Note:</strong>
          The first question in a quiz doesn't need a page break, as it will
          automatically be the first page.
        </div>
      {{/unless}}
    </div>
  </template>
}
